module.exports = __webpack_public_path__ + "assets/img/logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 1963
// module chunks = 0